import React from "react";
import { Card } from "react-bootstrap";
import "./MainCard.scss";

const MainCard = ({ children, className }) => {
  return <Card className={`mainCard_style ${className}`}>{children}</Card>;
};

export { MainCard };
